module.exports = __webpack_public_path__ + "static/media/oakland.c7f711a3.jpg";